import React, { Component } from "react";
import intl from "react-intl-universal";
import ViewRouter from "@/router/index";
import { LocaleProvider } from './LocaleContext';

const locales = {
  en: require("./locales/localesLang/en-US.json"),
  zh: require("./locales/localesLang/zh-CN.json"),
};

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initDone: false,
    };
  }

  componentDidMount() {
    this.getLanges();
  }
  getLanges = () => {
    const lang = (navigator.language || navigator.browserLanguage).toLowerCase();
    const defaultLang = lang.includes("zh") ? "zh" : "en";
    localStorage.setItem("defaultLng", defaultLang);

    const currentLocale = localStorage.getItem("locale") || defaultLang;
    this.loadLocales(currentLocale);
  };
  loadLocales = (locale) => {
    intl
      .init({
        currentLocale: locale,
        locales,
      })
      .then(() => {
        this.setState({ initDone: true });
      });
  };

  render() {
    return (
      this.state.initDone && (
        <>
		  <LocaleProvider>
          	<div key={intl.getInitOptions().currentLocale}>
				<ViewRouter />
			</div>
			</LocaleProvider>
        </>
      )
    );
  }
}